module.exports = __webpack_public_path__ + "static/media/cube.f5e20fd7.png";